import type {Destructible} from './types';

export const isDestructible = (store: unknown): store is Destructible => {
  return typeof (store as Destructible).destruct === 'function';
};
